import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import locationService from "../Services/locationService";
import toast from "react-hot-toast";
import DeleteModal from "../Components/DeleteModal";
import Loading from "../Modals/Loading";
import Head from "../Components/Head";
import { LuEye } from "react-icons/lu";
import { HiOutlineTrash } from "react-icons/hi";

const Locations = () => {
  const [data, setData] = useState([]);
  const [deleteID, setDeleteID] = useState();
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);

  const initiateDelete = (id) => {
    setOpen(true);
    setDeleteID(id);
  };

  const handleDelete = async () => {
    try {
      await locationService.deleteLocation(deleteID);
      setTrigger(!trigger);
      toast.success("Location deleted successfully");
      setOpen(false);
    } catch (error) {
      toast.error("Failed to delete location");
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    const getLocations = async () => {
      try {
        setLoading(true);
        const response = await locationService.getAllLocations();
        setData(response.data);
        console.log("res", response.locations);
        console.log("res", response.data);
      } catch (error) {
        toast.error("Failed to fetch locations");
      } finally {
        setLoading(false);
      }
    };
    getLocations();
  }, [trigger]);

  const navigate = useNavigate();
  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <Head
        heading={"Location"}
        button_text={"Add Location"}
        navigation={() => navigate("/locations/add")}
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          <DeleteModal
            open={open}
            setOpen={setOpen}
            deleteFunction={handleDelete}
            deleting={deleting}
          />
          {data && data.length > 0 ? (
            <div className="table-div">
              <table className="w-full">
                <thead className="border-y-2 text-center text-black text-[10px]">
                  <tr>
                    <th className="py-4">Sr No.</th>
                    <th className="py-4">Name</th>
                    <th className="py-4">Number</th>
                    <th className="py-4">Type</th>
                    <th className="py-4">Area</th>
                    <th className="py-4">Warehouse</th>
                    <th className="py-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((location, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-200 text-center text-[11px]"
                    >
                      <td className="py-4 font-bold text-blue-500">
                        {index + 1}.
                      </td>
                      <td className="py-4">{location.name}</td>
                      <td className="py-4">{location.number}</td>
                      <td className="py-4">{location.type}</td>
                      <td className="py-4">{location.area}</td>
                      <td className="py-4">{location.warehouse}</td>
                      <td className="py-4">
                        <button
                          onClick={() => initiateDelete(location.id)}
                          className="text-red-500"
                        >
                          <HiOutlineTrash className="h-4 w-4 text-red-500" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}
        </>
      )}
    </main>
  );
};

export default Locations;
